import { apiFetch } from '@/lib/api';

export interface AiProviderModel {
  model: string;
  input_price: number;
  output_price: number;
}

export interface AiProvider {
  provider: 'anthropic' | 'openai' | 'deepseek' | 'qwen';
  enabled: boolean;
  hasKey: boolean;
  source: 'db' | 'env' | 'none';
  keyMasked: string;
  models: AiProviderModel[];
}

export function getAiProviders(): Promise<AiProvider[]> {
  return apiFetch<AiProvider[]>('/ai-providers');
}

export function updateAiProvider(
  provider: string,
  body: { api_key?: string; enabled?: boolean },
): Promise<Omit<AiProvider, 'models'>> {
  return apiFetch(`/ai-providers/${provider}`, { method: 'PUT', body: JSON.stringify(body) });
}

export function testAiProvider(
  provider: string,
): Promise<{ ok: boolean; message?: string; error?: string }> {
  return apiFetch(`/ai-providers/${provider}/test`, { method: 'POST', body: JSON.stringify({}) });
}
